<template>
    <header class="header">
        <!-- PC 헤더 -->
        <div class="header-primary-container">
            <div class="header-primary">
                <!-- <div class="header-primary__top">
                    <div class="container">
                        <ul>
                            <li><a href="#" target="_blank">e바꿈</a></li>
                            <li><a href="https://yknowledge.uxi.kr/" target="_blank">e이음</a></li>
                            <li><a href="/support/total">e만듦</a></li>
                        </ul>
                    </div>
                </div> -->
                <div class="header-primary__contents">
                    <div class="header-primary__forward">
                        <div class="header-logo">
                            <h1>
                                <router-link to="/" title="홈으로 이동">
                                    <span class="blind">KEA전자제조지원센터</span>
                                </router-link>
                            </h1>
                        </div>
                        <!-- 모바일 사이드바 토글 버튼 -->
                        <div class="mobile-menu">
                            <button type="button" aria-pressed="false" class="button">
                                <span></span>
                            </button>
                        </div>
                    </div>
                    <!-- <div class="header-search">
                        <form class="header-search__form">
                            <input v-model="searchValue" class="header-search__input" type="text" name="" value="" placeholder="검색어를 입력하세요" />
                            <button class="header-search__button" @click="search"></button>
                        </form>
                    </div> -->

                    <div class="header-primary__body">
                        <div class="header-primary__main">
                            <div class="header-primary__main-inner">
                                <ul class="header-menu-lists">
                                    <!--
                                        ※1뎁스 활성화시 a.link에 서브 클래스 추가
                                        서브 클래스명: link--on
                                    -->
                                    <li class="header-menu-list">
                                        <router-link to="/about" class="link"><h2>전자제조지원센터</h2></router-link>
                                        <ul class="header-menu-sub">
                                            <li><router-link to="/about" class="sub-link"><span>센터개요</span></router-link></li>
                                            <li><router-link to="/about/equipments" class="sub-link"><span>장비소개</span></router-link></li>
                                            <li><a href="https://kea-editor-blacksmith.uxi.kr" target="_blank" class="sub-link"><span>지원제품</span></a></li>
                                            <!-- <li><a class="sub-link"  @click.prevent="alert('준비중입니다')"><span>장비소개</span></a></li> -->
                                            <li><router-link to="/about/location" class="sub-link"><span>오시는길</span></router-link></li>
                                        </ul>
                                    </li>
                                    <li class="header-menu-list">
                                        <router-link to="/rental/intro" class="link"><h2>시설·장비예약</h2></router-link>
                                        <ul class="header-menu-sub">
                                            <li><router-link to="/rental/intro" class="sub-link"><span>예약 절차 안내</span></router-link></li>
                                            <li><router-link :to="`/rental/${RENTAL_SUBJECT_TYPES.EQUIPMENTS.value.toLowerCase()}`" class="sub-link"><span>장비 사용 신청</span></router-link></li>
                                            <li><router-link :to="`/rental/${RENTAL_SUBJECT_TYPES.FACILITIES.value.toLowerCase()}`" class="sub-link"><span>시설 사용 신청</span></router-link></li>
                                        </ul>
                                    </li>
                                    <li class="header-menu-list">
                                        <router-link to="/service/about" class="link"><h2>제조지원·교육</h2></router-link>
                                        <ul class="header-menu-sub">
                                            <li><router-link to="/service/about" class="sub-link"><span>지원서비스 안내</span></router-link></li>
                                            <li><router-link to="/service/supports" class="sub-link"><span>지원 신청</span></router-link></li>
                                            <li><router-link to="/service/programs" class="sub-link"><span>교육 신청</span></router-link></li>
                                        </ul>
                                    </li>
                                    <!-- <li class="header-menu-list">
                                        <router-link to="/application/edu" class="link"><h2>서비스신청</h2></router-link>
                                        <ul class="header-menu-sub">
                                            <li><router-link to="/application/edu" class="sub-link"><span>교육</span></router-link></li>
                                            <li><router-link to="/application/unit" class="sub-link"><span>단위지원</span></router-link></li>
                                            <li><router-link to="/application/total" class="sub-link"><span>토탈지원</span></router-link></li>
                                        </ul>
                                    </li> -->
                                    <li class="header-menu-list">
                                        <router-link to="/community/notice" class="link"><h2>커뮤니티</h2></router-link>
                                        <ul class="header-menu-sub">
                                            <li><router-link to="/community/notice" class="sub-link"><span>공지사항</span></router-link></li>
                                            <li><router-link to="/community/reference" class="sub-link"><span>자료실</span></router-link></li>
                                            <li><router-link to="/community/qna" class="sub-link"><span>QnA</span></router-link></li>
                                        </ul>
                                    </li>
                                </ul>
                                <div class="header-primary-dimmed"></div>
                            </div>
                        </div>
                    </div>

                    <div class="header-primary__right">
                        <!-- <div class="header-primary__global">
                            <i class="icon icon-language"></i><locale-select></locale-select>
                        </div> -->
                        <gnb-login-button class="header-customer-lists"/>
                        <!-- <router-link to="/estimate/estimate-inquiry" class="header-primary__right-inquiry"><span class="blind">견적신청 1566-7777</span></router-link> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- // PC 헤더 -->

        <!-- Mobile 헤더 -->
        <div class="mobile-sidebar">
            <div class="mobile-sidebar__head">
                <button class="mobile-sidebar__close" type="button"><span class="blind">모바일 메뉴바 닫기</span></button>
                <!-- <div class="mobile-sidebar-info">
                    <router-link class="member-name" to="/login">
                        <span>로그인 해주세요</span>
                        <span></span>
                    </router-link>
                </div> -->
                <!-- <div class="mobile-sidebar__global">
                    <i class="icon icon-language"></i><locale-select></locale-select>
                </div> -->
            </div>
            <div class="mobile-sidebar__link">
                <gnb-login-button class="mobile-gnb-link" />
            </div>
            <div class="mobile-sidebar__body">
                <ul class="mobile-category__lists">
                    <li class="mobile-category__list" data-category-order>
                        <div class="mobile-category__list-link" data-toggle="closed">
                            <span>전자제조지원센터</span><div class="arrow"></div>
                        </div>
                        <ul class="mobile-category__level">
                            <li><router-link to="/about" class="mobile-category__level-link"><span>센터개요</span></router-link></li>
                            <li><router-link to="/about/equipments" class="mobile-category__level-link"><span>장비소개</span></router-link></li>
                            <!-- <li><a class="mobile-category__level-link" @click.prevent="alert('준비중입니다')"><span>장비소개</span></a></li> -->
                            <li><router-link to="/about/location" class="mobile-category__level-link"><span>오시는 길</span></router-link></li>
                        </ul>
                    </li>
                    <!-- <li class="mobile-category__list" data-category-order>
                        <div class="mobile-category__list-link" data-toggle="closed">
                            <span>장비 및 시설</span><div class="arrow"></div>
                        </div>
                        <ul class="mobile-category__level">
                            <li><router-link to="/possess/equipment" class="mobile-category__level-link"><span>보유장비</span></router-link></li>
                            <li><router-link to="/possess/facilities" class="mobile-category__level-link"><span>보유시설</span></router-link></li>
                        </ul>
                    </li> -->
                    <li class="mobile-category__list" data-category-order>
                        <div class="mobile-category__list-link" data-toggle="closed">
                            <span>시설·장비예약</span><div class="arrow"></div>
                        </div>
                        <ul class="mobile-category__level">
                            <li><router-link to="/rental/intro" class="mobile-category__level-link"><span>예약 절차 안내</span></router-link></li>
                            <li><router-link :to="`/rental/${RENTAL_SUBJECT_TYPES.EQUIPMENTS.value.toLowerCase()}`" class="mobile-category__level-link"><span>장비 사용 신청</span></router-link></li>
                            <li><router-link :to="`/rental/${RENTAL_SUBJECT_TYPES.FACILITIES.value.toLowerCase()}`" class="mobile-category__level-link"><span>시설 사용 신청</span></router-link></li>
                            <!-- <li><router-link to="/support/edu" class="mobile-category__level-link"><span>단기교육</span></router-link></li> -->
                        </ul>
                    </li>
                    <li class="mobile-category__list" data-category-order>
                        <div class="mobile-category__list-link" data-toggle="closed">
                            <span>제조지원·교육</span><div class="arrow"></div>
                        </div>
                        <ul class="mobile-category__level">
                            <li><router-link to="/service/about" class="mobile-category__level-link"><span>지원서비스 안내</span></router-link></li>
                            <li><router-link to="/service/supports/unit" class="mobile-category__level-link"><span>지원 신청</span></router-link></li>
                            <li><router-link to="/service/programs" class="mobile-category__level-link"><span>교육 신청</span></router-link></li>
                        </ul>
                    </li>
                    <!-- <li class="mobile-category__list" data-category-order>
                        <div class="mobile-category__list-link" data-toggle="closed">
                            <span>서비스신청</span><div class="arrow"></div>
                        </div>
                        <ul class="mobile-category__level">
                            <li><router-link to="/application/edu" class="mobile-category__level-link"><span>교육</span></router-link></li>
                            <li><router-link to="/application/unit" class="mobile-category__level-link"><span>단위지원</span></router-link></li>
                            <li><router-link to="/application/total" class="mobile-category__level-link"><span>토탈지원</span></router-link></li>
                        </ul>
                    </li> -->
                    <li class="mobile-category__list" data-category-order>
                        <div class="mobile-category__list-link" data-toggle="closed">
                            <span>커뮤니티</span><div class="arrow"></div>
                        </div>
                        <ul class="mobile-category__level">
                            <li><router-link to="/community/notice" class="mobile-category__level-link"><span>공지사항</span></router-link></li>
                            <li><router-link to="/community/reference" class="mobile-category__level-link"><span>자료실</span></router-link></li>
                            <li><router-link to="/community/qna" class="mobile-category__level-link"><span>QnA</span></router-link></li>
                        </ul>
                    </li>
                    <!-- <li class="mobile-category__list" data-category-order>
                        <router-link to="/center/notice" class="mobile-category__list-link"><span>공지사항</span></router-link>
                    </li> -->
                </ul>
                <!-- <ul class="mobile-usermenu__lists">
                    <li class="mobile-usermenu__list"><router-link to="/center/notice" class="mobile-usermenu__list-link"><span>공지사항</span></router-link></li>
                    <li class="mobile-usermenu__list"><router-link to="/center/notice" class="mobile-usermenu__list-link"><span>공지사항</span></router-link></li>
                </ul> -->
            </div>
            <!-- <div class="mobile-sidebar__foot">
                <gnb-login-button class="mobile-foot-link"/>
            </div> -->
        </div>
        <div class="mobile-sidebar-dimmed"></div>
        <!-- // Mobile 헤더 -->
    </header>
</template>

<script>
import api from "@/api";
import { RENTAL_SUBJECT_TYPES } from '@/assets/variables';

import { Header } from "@/plugins/header.js"; // Sticky & Heaer 스크립트
import LocaleSelect from "@/components/client/inc/locale-select.vue";
import GnbLoginButton from "@/components/client/login/gnb-login-button.vue";

export default {
    components: {
        LocaleSelect,
        GnbLoginButton,
    },
    data: () => ({
        RENTAL_SUBJECT_TYPES,
    }),
    mounted() {
        this.header();
        window.scrollTo(0, 0); // 라우터 이동 시 스크롤 상단부터 시작
    },
    methods: {
        header: function() {
            this.$nextTick(function() {
                Header(); // Sticky & Heaer 스크립트 로드
            });
        },
        alert(message) {
            alert(message);
        },
    },
};
</script>